import { render, staticRenderFns } from "./account-layout.vue?vue&type=template&id=5fa097a4&scoped=true"
import script from "./account-layout.vue?vue&type=script&lang=js"
export * from "./account-layout.vue?vue&type=script&lang=js"
import style0 from "./account-layout.vue?vue&type=style&index=0&id=5fa097a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa097a4",
  null
  
)

export default component.exports